import Section from '@/components/layout/Section'
import Tag from '@/components/ui/Tag'
import ClientLogos from '@/components/home/ClientLogos'
import { bio } from '@/data/projects'

const skills = [
  'Product Motion',
  'Motion Design Systems',
  'Brand Storytelling',
  'User Acquisition Videos',
  'Product Presentations',
  'Google Material Motion',
  'Apple HIG',
  'Interaction Design',
  'Accessibility Design',
  'Adobe Creative Suite',
  '2D',
  '3D',
  'Lottie',
  'Animation Tokens',
  'Midjourney',
  'Claude',
  'Generative AI',
]

export default function AboutSection() {
  return (
    <Section id="about" className="pt-6 pb-8 md:pb-12">
      <h2 className="text-h2 text-text-primary mb-8 md:mb-12">About</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
        <div className="flex flex-col gap-6">
          <p className="text-body text-text-secondary leading-relaxed">{bio.summary}</p>
        </div>
        <div className="flex flex-col gap-4">
          <h3 className="text-label uppercase tracking-widest text-text-muted">Specialities and Tools</h3>
          <div className="flex flex-wrap gap-2">
            {skills.map((skill) => (
              <Tag key={skill} label={skill} />
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6 md:mt-8 pt-6 md:pt-8 border-t border-border">
        <ClientLogos />
      </div>
    </Section>
  )
}
